import React from "react";
import { css } from "@emotion/core";
import BeatLoader from "react-spinners/BeatLoader";

interface Props {
  size: number;
  color?: string;
}

const styles = css`
  margin: 0 auto;
`;

const EllipsisLoader: React.FunctionComponent<Props> = ({ size, color }) => (
  <BeatLoader css={styles} size={size} color={color} />
);

export default EllipsisLoader;
